(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["galrie-hero"] && !Shopify.designMode) return;
  try {
    

  if(!customElements.get('galrie-hero')){
    // Source coordinates in the original room photographs. The bottom landmark
    // is the trolley, console or seating group that establishes the print's scale.
    const roomFraming={
      'carpano-desktop':{w:1817,h:866,centre:1205,top:252,frameW:163,frameH:217,bottom:705,screenX:.64,zoom:1.45},
      'surf-desktop':{w:1816,h:866,centre:1242,top:274,frameW:289,frameH:202,bottom:710,screenX:.65,zoom:1.40},
      'matisse-desktop':{w:1817,h:866,centre:1273,top:251,frameW:177,frameH:249,bottom:731,screenX:.66,zoom:1.50},
      'carpano-mobile':{w:941,h:1672,centre:479,top:378,frameW:198,frameH:265,bottom:860,screenX:.50,zoom:1.45},
      'surf-mobile':{w:941,h:1672,centre:549,top:475,frameW:340,frameH:244,bottom:915,screenX:.51,zoom:1.25},
      'matisse-mobile':{w:941,h:1672,centre:601,top:431,frameW:206,frameH:290,bottom:946,screenX:.53,zoom:1.40}
    };
    const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));
    customElements.define('galrie-hero',class extends HTMLElement{
      connectedCallback(){
        if(this.heroController)return;
        this.heroController=new AbortController();
        const signal=this.heroController.signal;
        this.scheduleFold=()=>{
          cancelAnimationFrame(this.foldFrame);
          this.foldFrame=requestAnimationFrame(()=>this.fitFold());
        };
        window.addEventListener('resize',this.scheduleFold,{signal});
        window.addEventListener('load',this.scheduleFold,{signal});
        this.headerObserver=new ResizeObserver(this.scheduleFold);
        document.querySelectorAll('.header-wrapper, .shopify-section-group-header-group').forEach(element=>this.headerObserver.observe(element));
        document.fonts.ready.then(()=>{if(this.isConnected)this.scheduleFold();});
        this.scheduleFold();
        this.slides=Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.tabs=Array.from(this.querySelectorAll('[data-slide-to]'));
        this.activeIndex=Math.max(0,this.slides.findIndex(slide=>!slide.hidden));
        const nav=this.querySelector('.ghr__navigation');
        if(nav)nav.hidden=false;
        this.setupCropReview(signal);
        this.tabs.forEach((tab,index)=>{
          tab.addEventListener('click',()=>this.showSlide(index),{signal});
          tab.addEventListener('keydown',event=>{
            let next=null;
            if(event.key==='ArrowRight')next=(index+1)%this.tabs.length;
            if(event.key==='ArrowLeft')next=(index+this.tabs.length-1)%this.tabs.length;
            if(event.key==='Home')next=0;
            if(event.key==='End')next=this.tabs.length-1;
            if(next!==null){event.preventDefault();this.showSlide(next);this.tabs[next].focus();}
          },{signal});
        });
        this.addEventListener('pointerdown',event=>{
          if(event.pointerType==='touch'&&event.target.closest('.ghr__media'))this.swipeStart={x:event.clientX,y:event.clientY};
        },{signal});
        this.addEventListener('pointerup',event=>{
          if(!this.swipeStart)return;
          const dx=event.clientX-this.swipeStart.x,dy=event.clientY-this.swipeStart.y;
          this.swipeStart=null;
          if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)this.showSlide((this.activeIndex+(dx<0?1:-1)+this.slides.length)%this.slides.length);
        },{signal});
        this.addEventListener('pointercancel',()=>{this.swipeStart=null;},{signal});
        document.addEventListener('shopify:block:select',event=>{
          if(!this.contains(event.target))return;
          const index=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);
          if(index>=0)this.showSlide(index);
        },{signal});
      }
      setupCropReview(signal){
        const panel=this.querySelector('.ghr__crop');
        if(!panel || window.Shopify?.theme?.role==='main')return;
        const input=panel.querySelector('input');
        const output=panel.querySelector('output');
        const copy=panel.querySelector('[data-copy-crops]');
        const device=matchMedia('(max-width:599px)');
        const mode=()=>device.matches?'mobile':'desktop';
        const property=key=>'--ghr-'+key+'-zoom';
        const percent=(slide,key)=>Math.round(Number(slide.style.getPropertyValue(property(key))||1)*100);
        const refresh=()=>{
          const slide=this.slides[this.activeIndex];
          if(panel.hidden||!slide)return;
          const value=percent(slide,mode());
          input.value=String(value);
          input.setAttribute('aria-valuetext',value+' percent');
          output.textContent=value+'%';
          const name=this.tabs[this.activeIndex]?.textContent.replace(/^\s*\d+\s*/,'').trim()||'Slide';
          panel.querySelector('[data-crop-context]').textContent=name+' · '+mode();
          copy.textContent='Copy crop link';
        };
        const reviewHash=()=>{
          const params=new URLSearchParams({v:'2'});
          for(const slide of this.slides){
            for(const key of ['desktop','mobile'])params.set(slide.dataset.blockId+'-'+key,percent(slide,key));
          }
          params.set('slide',this.slides[this.activeIndex].dataset.blockId);
          return 'hero-zoom&'+params.toString();
        };
        const enable=()=>{
          const [name,...pairs]=location.hash.slice(1).split('&');
          panel.hidden=name!=='hero-zoom';
          if(panel.hidden)return;
          const params=new URLSearchParams(pairs.join('&'));
          if(params.get('v')!=='2'){refresh();return;}
          for(const slide of this.slides){
            for(const key of ['desktop','mobile']){
              const value=Number(params.get(slide.dataset.blockId+'-'+key));
              if(value>=100&&value<=220&&value%5===0)slide.style.setProperty(property(key),value/100);
            }
          }
          const index=this.slides.findIndex(slide=>slide.dataset.blockId===params.get('slide'));
          if(index>=0)this.showSlide(index);
          else this.fitArtwork();
          refresh();
        };
        this.refreshCropReview=refresh;
        enable();
        window.addEventListener('hashchange',enable,{signal});
        device.addEventListener('change',refresh,{signal});
        input.addEventListener('input',()=>{
          this.slides[this.activeIndex].style.setProperty(property(mode()),Number(input.value)/100);
          this.fitArtwork();
          refresh();
        },{signal});
        input.addEventListener('change',()=>{
          history.replaceState(history.state,'','#'+reviewHash());
        },{signal});
        copy.addEventListener('click',async()=>{
          const url=new URL(location.href);
          if(window.Shopify?.theme?.id)url.searchParams.set('preview_theme_id',window.Shopify.theme.id);
          url.hash=reviewHash();
          try{
            await navigator.clipboard.writeText(url.href);
            copy.textContent='Copied';
          }catch{
            window.prompt('Copy this crop preview link',url.href);
          }
        },{signal});
      }
      fitArtwork(){
        const slide=this.slides?.[this.activeIndex];
        if(!slide)return;
        const picture=slide.querySelector('picture');
        if(!picture)return;
        const img=picture.querySelector('img');
        const mobile=matchMedia('(max-width:599px)').matches;
        const url=mobile?picture.querySelector('source')?.srcset:img.getAttribute('src');
        const key=url?.match(/galrie-(carpano|surf|matisse)-(desktop|mobile)-aligned\.webp/);
        const room=key&&roomFraming[key[1]+'-'+key[2]];
        if(!room){img.removeAttribute('data-room-fit');return;}
        const width=slide.clientWidth,height=slide.clientHeight;
        if(!width||!height)return;
        const zoom=Number(slide.style.getPropertyValue(mobile?'--ghr-mobile-zoom':'--ghr-desktop-zoom'))||1;
        const cover=Math.max(width/room.w,height/room.h);
        const copyTop=slide.querySelector('.ghr__copy').getBoundingClientRect().top-slide.getBoundingClientRect().top;
        const gap=mobile?clamp(height*.065,18,46):height*.105;
        const sceneBottom=mobile?Math.min(height*.59,copyTop+12):height*.965;
        const groupScale=(sceneBottom-gap)/(room.bottom-room.top);
        const frameScale=Math.min((mobile?copyTop-gap-12:height*.76)/room.frameH,width*(mobile?.78:.4)/room.frameW);
        const scale=Math.max(cover,Math.min(cover*zoom,groupScale*zoom/room.zoom,frameScale));
        const scaledWidth=room.w*scale,scaledHeight=room.h*scale;
        const left=clamp(width*room.screenX-room.centre*scale,width-scaledWidth,0);
        const top=clamp(gap-room.top*scale,height-scaledHeight,0);
        for(const [name,value] of Object.entries({left,top,width:scaledWidth,height:scaledHeight})){
          img.style.setProperty('--room-'+name,value.toFixed(2)+'px');
        }
        img.setAttribute('data-room-fit','');
      }
      fitFold(){
        const offset=Math.max(0,Math.ceil(this.getBoundingClientRect().top+window.scrollY));
        const value=offset+'px';
        if(this.style.getPropertyValue('--ghr-offset')!==value)this.style.setProperty('--ghr-offset',value);
        const mobile=window.matchMedia('(max-width:599px)').matches;
        const height=Math.min(window.innerHeight-offset-12,this.clientWidth*(mobile?1024/624:900/1536));
        this.classList.toggle('ghr--compact',height<(mobile?570:520));
        this.fitArtwork();
      }
      showSlide(index){
        if(index<0||index>=this.slides.length)return;
        this.activeIndex=index;
        this.slides.forEach((slide,i)=>{
          slide.hidden=i!==index;
          slide.classList.toggle('is-active',i===index);
          if(i===index){const img=slide.querySelector('img');if(img)img.loading='eager';}
        });
        this.tabs.forEach((tab,i)=>tab.setAttribute('aria-pressed',String(i===index)));
        this.fitArtwork();
        this.refreshCropReview?.();
        const title=this.slides[index].querySelector('.ghr__heading');
        this.querySelector('.ghr__announcement').textContent=title?title.textContent:'';
      }
      disconnectedCallback(){
        if(this.heroController)this.heroController.abort();
        this.heroController=null;
        if(this.headerObserver)this.headerObserver.disconnect();
        cancelAnimationFrame(this.foldFrame);
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.headerCoords = {};
    this.calcHeaderCoords()

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	calcHeaderCoords() {
    const clientRect = this.getBoundingClientRect();
    const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
    this.headerCoords.bottom = pageYOffset + clientRect.bottom;
    this.headerCoords.top = pageYOffset + clientRect.top;
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					this.header.classList.add('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					this.header.classList.remove('color-background-overlay-hidden', 'shopify-section-header-sticky');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerCoords.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
